export default __webpack_public_path__ + "static/media/deezer.fe191f34.svg";